export default __webpack_public_path__ + "static/media/shakespeare-2.b950891a.png";